<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      {{ appBrandName }}
      <span class="d-none d-sm-inline-block"> © 2022 - {{ new Date().getFullYear() }}</span>
    </span>

    <span class="float-md-right d-none d-md-block">
      <b-img
        height="30"
        :src="imgSrc"
        alt="logo"
      />
    </span>
  </p>
</template>

<script>
import { BImg } from 'bootstrap-vue'

export default {
  components: {
    BImg,
  },
  data() {
    return {
      appBrandName: process.env.VUE_APP_BRAND_NAME,
    }
  },
  computed: {
    imgSrc() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/images/logo/${process.env.VUE_APP_LOGO_FOOTER}`)
    },
  },
}
</script>
